import { useMemo } from 'react';

import useDataLayer from '@/hooks/useDataLayer';

const DataLayer = () => {
  const event = useMemo(
    () => ({
      event: 'pageView',
      pageType: 'Frequently Asked Questions Page',
    }),
    [],
  );

  useDataLayer(event);

  return null;
};

export default DataLayer;
